<template>
  <v-card class="trezo-card bg-white border-0 shadow-none border-radius mb-0">
    <div class="v-card-header">
      <h5 class="mb-0">Token Tüketimi (Zaman Serisi)</h5>
    </div>
    <div class="p-3">
      <div v-if="!timeseries.labels.length" class="text-muted py-4 text-center">
        Veri bulunamadı
      </div>
      <apexchart
        v-else
        type="area"
        height="280"
        :options="chartOptions"
        :series="timeseries.series"
      />
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ApexOptions } from 'apexcharts'
import type { TimeSeries } from '@/services/adminStatsApi'

const props = defineProps<{ timeseries: TimeSeries }>()

function formatToken(v: number): string {
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(1) + 'M'
  if (v >= 1_000) return Math.round(v / 1_000) + 'K'
  return v.toString()
}

const chartOptions = computed<ApexOptions>(() => ({
  chart: { toolbar: { show: false }, zoom: { enabled: false } },
  stroke: { curve: 'smooth', width: 2 },
  colors: ['#8b5cf6'],
  fill: {
    type: 'gradient',
    gradient: { opacityFrom: 0.35, opacityTo: 0.0, shadeIntensity: 1 },
  },
  dataLabels: { enabled: false },
  xaxis: {
    categories: props.timeseries.labels,
    tickAmount: 8,
    labels: { rotate: -30, style: { fontSize: '11px' } },
  },
  yaxis: { labels: { formatter: formatToken } },
  tooltip: {
    shared: true,
    intersect: false,
    y: { formatter: (v: number) => v.toLocaleString('tr-TR') + ' token' },
  },
}))
</script>
